<template>
  <div class="vx-row">
    <label
      v-if="$slots.label || !vertical || helpAsTooltip"
      :class="{ 'sm:w-1/4 sm:text-right': !vertical, 'sm:pt-2': !inline }"
      class="vx-col w-full pt-0">
      <slot name="label"></slot>
      <span v-if="required" class="text-danger"> *</span>
      <FieldHelp v-if="helpAsTooltip" :text="help" class="ml-1" />
    </label>
    <div :class="{ 'sm:w-3/4 ': !vertical }" class="vx-col w-full">
      <slot name="field"></slot>
      <p v-if="help && !helpAsTooltip" class="text-sm mt-2 opacity-75">{{ help }}</p>
    </div>
  </div>
</template>

<script>
import FieldHelp from "@/components/app/Form/FieldHelp.vue"
import { FIELD_HELP_MODE } from "@/common/constants/fieldHelp"

export default {
  name: "form-row",

  components: {
    FieldHelp,
  },

  inheritAttrs: true,

  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    // what the field is for: an info icon beside the label or a line under the field, by FIELD_HELP_MODE
    help: {
      type: String,
      default: "",
    },
  },

  computed: {
    helpAsTooltip() {
      return !!this.help && FIELD_HELP_MODE === "tooltip"
    },
  },
}
</script>

<style scoped></style>
